import { render, staticRenderFns } from "./FilePond.vue?vue&type=template&id=6a08c141"
import script from "./FilePond.vue?vue&type=script&lang=js"
export * from "./FilePond.vue?vue&type=script&lang=js"
import style0 from "./FilePond.vue?vue&type=style&index=0&id=6a08c141&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports